module.exports = __webpack_public_path__ + "img/goETC.6e66c2d8.png";